// lower left
import T31 from "./lower-left/T31";
import T32 from "./lower-left/T32";
import T33 from "./lower-left/T33";
import T34 from "./lower-left/T34";
import T35 from "./lower-left/T35";
import T36 from "./lower-left/T36";
import T37 from "./lower-left/T37";
import T38 from "./lower-left/T38";

//  lower right
import T41 from "./lower-right/T41";
import T42 from "./lower-right/T42";
import T43 from "./lower-right/T43";
import T44 from "./lower-right/T44";
import T45 from "./lower-right/T45";
import T46 from "./lower-right/T46";
import T47 from "./lower-right/T47";
import T48 from "./lower-right/T48";

//  upper left
import T21 from "./upper-left/T21";
import T22 from "./upper-left/T22";
import T23 from "./upper-left/T23";
import T24 from "./upper-left/T24";
import T25 from "./upper-left/T25";
import T26 from "./upper-left/T26";
import T27 from "./upper-left/T27";
import T28 from "./upper-left/T28";

//  upper right
import T11 from "./upper-right/T11";
import T12 from "./upper-right/T12";
import T13 from "./upper-right/T13";
import T14 from "./upper-right/T14";
import T15 from "./upper-right/T15";
import T16 from "./upper-right/T16";
import T17 from "./upper-right/T17";
import T18 from "./upper-right/T18";

const TEETH_SVGS = {
  11: T11,
  12: T12,
  13: T13,
  14: T14,
  15: T15,
  16: T16,
  17: T17,
  18: T18,
  21: T21,
  22: T22,
  23: T23,
  24: T24,
  25: T25,
  26: T26,
  27: T27,
  28: T28,
  31: T31,
  32: T32,
  33: T33,
  34: T34,
  35: T35,
  36: T36,
  37: T37,
  38: T38,
  41: T41,
  42: T42,
  43: T43,
  44: T44,
  45: T45,
  46: T46,
  47: T47,
  48: T48,
};

export default TEETH_SVGS;
